import { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { inkSpacingTokens } from '@ds/tokens';
import { breakpoints } from '@ds/ui';
import breakpointSizes from 'layouts/ApplicationLayout/objects/breakpointSizes/breakpointSizes';

interface ContainerLayoutInnerContentProps {
    className?: string;
    dataQa?: string;
}

const ContainerLayoutInnerContentContainer = styled.div`
    padding-bottom: ${inkSpacingTokens.spacingM};

    &.narrow > * {
        max-width: 380px;
    }

    & > p:first-of-type {
        margin-top: inherit;
    }

    & + & {
        margin-top: 0;
    }

    & > &:last-of-type {
        padding-bottom: 0;
    }

    // DESKTOP
    ${breakpoints.greaterThan(breakpointSizes.xs)} {
        .narrow-desktop {
            width: 50%;
        }
    }

    /* flexible application footer for mobile */
    ${breakpoints.lessThan(breakpointSizes.xs)} {
        flex-grow: 1;
        padding-bottom: 0;
    }
`;

const ContainerLayoutInnerContent: FunctionComponent<ContainerLayoutInnerContentProps> = ({ children, className, dataQa }) => (
    <ContainerLayoutInnerContentContainer className={`container ${className || ''}`} data-qa={dataQa}>
        {children}
    </ContainerLayoutInnerContentContainer>
);

export default ContainerLayoutInnerContent;
